import { LibraryCategory } from '@/store/modules/teamlibrary/types'

export default {
  libraryModelUID(state: any): number {
    return state.libraryEntry.Item.Id || -1
  },
  libraryPublicCategoriesIDs(state: any): number[] {
    if (
      state.libraryPublicCategories == null ||
      state.libraryPublicCategories.Categories == null
    ) {
      return []
    }

    return state.libraryPublicCategories.Categories.map((category: LibraryCategory) => category.CategoryId)
  }
}
